import { filter, length } from "@pdfking/rfunc"
import Icon from "@pdfking/workflow/components/Icon"
import make_translations from "@pdfking/workflow/utils/make_translations"
import delete_property from "@pdfking/workflow/vue/3/delete_property"
import set_property from "@pdfking/workflow/vue/3/set_property"
import { defineComponent } from "vue"
import close from "../../../mixins/Close"
import state from "../../../state/main"

export default defineComponent({
  computed: {
    translations: () => make_translations("actions"),
  },
  data() {
    return {
      expanded: {} as Record<string, boolean>,
      selected: {} as Record<string, any>,
    }
  },
  methods: {
    delete_property,
    is_expanded(id: string) {
      return this.expanded[id]
    },
    length,

    set_property,
    toggle_expanded(id: string) {
      set_property(this.expanded, id, !this.expanded[id])

      if (this.expanded[id]) {
        // @ts-expect-error - track_event method on state
        state.track_event("menu_expand", "menu")
      }
    },
    truncate_links(page: any) {
      if (this.is_expanded(page.id)) {
        return page.descendants
      }

      return filter(
        (_page: any, index: number) => index < this.expandSize,
        page.descendants
      )
    },
  },
  mixins: [close],
  props: {
    expandSize: {
      default: 6,
      type: Number,
    },
    pages: {
      default: () => [],
      type: Array,
    },
  },
  render() {
    if (length(this.pages) == 0) {
      return (
        <div class="display-5 mt-4">{this.translations.actions.NO_RESULTS}</div>
      )
    }

    return (
      <div class="row pt-4">
        {(this.pages as any[]).map((page: any) => (
          <div
            key={page.id}
            class="col col-6 col-lg-4"
            style={{ order: page.kind_sequence }}
          >
            <div class="megamenu-section row-space markdown-compact">
              {(this.selected[page.id] || page.img) && (
                <a
                  class="megamenu-preview rounded"
                  data-track-event="menu_link"
                  data-track-type="menu"
                  href={page.url}
                  style={{
                    "background-image":
                      "url(" +
                      (this.selected[page.id]
                        ? this.selected[page.id].img
                        : page.img) +
                      ")",
                  }}
                  title={page.unicode}
                  onClick={this.close}
                />
              )}
              <a
                class="h6"
                data-track-event="menu_link"
                data-track-type="menu"
                href={page.url}
                title={page.unicode}
                onClick={this.close}
              >
                {page.icon && <Icon name={page.icon} />}
                {page.unicode}
              </a>
              {length(page.descendants) == 0 ? (
                <p class="small markdown" innerHTML={page.description}></p>
              ) : (
                <div class="d-flex flex-column">
                  {this.truncate_links(page).map((sub: any) => (
                    <a
                      key={sub.id}
                      class="megamenu-link"
                      data-track-event="menu_link"
                      data-track-type="menu"
                      href={sub.url}
                      style={{ order: sub.kind_sequence }}
                      title={sub.unicode}
                      onClick={this.close}
                      onMouseout={() => delete_property(this.selected, page.id)}
                      onMouseover={() =>
                        set_property(this.selected, page.id, sub)
                      }
                    >
                      {sub.unicode}
                    </a>
                  ))}
                </div>
              )}
              {length(page.descendants) > this.expandSize && (
                <a
                  class="megamenu-expand"
                  href="#"
                  onClick={(e: Event) => {
                    e.preventDefault()
                    this.toggle_expanded(page.id)
                  }}
                >
                  {this.is_expanded(page.id)
                    ? this.translations.actions.HIDE
                    : this.translations.actions.SHOW_ALL +
                      " (" +
                      length(page.descendants) +
                      ")"}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    )
  },
})
